import styled from '@emotion/styled';

export const TeamSmallCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;

  border-radius: 8px;
  border: 1px #cccccc solid;
  background-color: #f2f2f2;

  transition: background-color 0.2s ease-in-out;

  &:hover {
    background: #ffe267;
  }
`;

export const TeamSmallList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 200px;
  overflow: auto;
`;

export const MomentsWrapper = styled.div`
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 40px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 280px);

  overflow-y: auto;
  scrollbar-gutter: 'stable';
`;

export const MomentPlayerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  border: 1px solid #2d2d47;
  width: calc(280px);
  height: calc(158px);
  overflow: hidden;
`;
